import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { endPoints } from "../../../config";
import { axiosInstnace, getAdminData } from "../../../util/util";
import Autocomplete from "../../common/Autocomplete.jsx";
import DatePicker from "react-datepicker";

const Modal = ({ isShowing, hide, admin }) => {
  const [count, handleCount] = useState(1);
  const [customer, handleCustomer] = useState("");
  const [justification, handleJustification] = useState("");
  const [coupontype, handleCoupontype] = useState("Percentage");
  const [validUntil, handleValidUntill] = useState("");
  const [frequency, handleFrequency] = useState("onetime");
  const [propValue, handleProposedValue] = useState("");
  const [user, handleuser] = useState(admin);
  const [advertisrers, handleadvertisers] = useState("");
  useEffect(() => {
    if (!user.email) {
      handleuser(JSON.parse(localStorage.getItem("salesUserInfo")));
    }
    getstates();
  }, [admin]);

  const closePopup = () => {
    hide();
    handleCount(1);
  };

  const addCustomer = (customer) => {
    handleCustomer(customer);
  };
  const getstates = async () => {
    let users = await axiosInstnace.get(endPoints.getSpecificRoleUsers, {params:{
      role:"user"
    }});
    users = users.data.data.map((e) => {
      return e.email;
    });

    let currentUserInfo = JSON.parse(localStorage.getItem("userInfo"));

    if(currentUserInfo.role != 'dsa'){
      let dsausers = await axiosInstnace.get(endPoints.getSpecificRoleUsers, {params:{
        role:"dsa"
      }});
      dsausers = dsausers.data.data.map((e) => {
        return e.email;
      });
  
      users = users.concat(dsausers);
    }
    
    handleadvertisers(users);
  };
  const updateRates = async (e) => {
    e.preventDefault();
    
    if (
      !customer ||
      !frequency ||
      !coupontype ||
      !justification || !validUntil ||
      !propValue
    ) {
      toast.error("All the fields are mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "1",
      });
      return;
    }
    const params = {
      customer,
      frequency,
      coupontype,
      propValue,
      requestBy: user.email,
      validUntil: +new Date(validUntil),justification,
      status: "Requested",
      date: +new Date(),
    };
    let result = await axiosInstnace.post(endPoints.requestCoupon, params);
    window.location.reload(true);
  };

  return isShowing ? (
    <div className="modal-overlay">
      <div
        className="modal-wrapper thankyou-popup"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div
          className="modal approval"
          //   style={{ height: "90vh", overflowY: "auto" }}
        >
          <div className="modal-head-cross rate-modal">
            <button
              type="button"
              className="modal-close-button"
              onClick={closePopup}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="approval-content modal-body">
              <div class="popup-container reqst-rejection">
                <h2>Request Coupon</h2>
                <table className="tableView">
                  <tr>
                    <td>
                      <label htmlFor="email">Justification</label>
                    </td>
                    <td>
                      <textarea
                        style={{ height: "10vh" }}
                        class="width200"
                        placeholder={
                          "Proposed campaign value, Station name, total seconds, final ER agreed with advertiser"
                        }
                        onChange={(e) => {
                          handleJustification(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="email">Advertiser Email</label>
                    </td>
                    <td>
                      <Autocomplete
                        suggestions={advertisrers}
                        addCustomer={addCustomer}
                        message={"Please select a valid advertiser Email"}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {" "}
                      <placeholderText> Frequency</placeholderText>
                    </td>
                    <td>
                      <select
                        name="trafficUpdate"
                        className="form-control"
                        value={frequency}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handleFrequency(e.target.value);
                        }}
                      >
                        <option value="onetime">One time</option>
                        <option value="multi">Multiple</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {" "}
                      <placeholderText> Coupon Type</placeholderText>
                    </td>
                    <td>
                      <select
                        name="weatherUpdate"
                        className="form-control"
                        value={coupontype}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handleCoupontype(e.target.value);
                        }}
                      >
                        <option value="Percentage">Percentage</option>
                        <option value="FlatRate">Flat Rate</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {" "}
                      <placeholderText> Proposed Value</placeholderText>
                    </td>
                    <td>
                      <input
                        name="weatherUpdate"
                        type="number"
                        className="form-control"
                        value={propValue}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handleProposedValue(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td> Valid Till</td>
                    <td>
                      {" "}
                      <DatePicker
                        selected={validUntil}
                        onChange={(date) => handleValidUntill(date)}
                        dateFormatCalendar={"MMM yyyy"}
                        minDate={new Date()}
                      />
                    </td>
                  </tr>
                </table>
                <div className="popupCampaign-container">
                  <div className="create-camp nonfct-submit">
                    <button
                      onClick={updateRates}
                      style={{
                        width: "100%",
                        height: "50px",
                        borderRadius: "10px",
                        color: "#fff",
                        backgroundColor: "#1f7cc0",
                      }}
                    >
                      REQUEST COUPON
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="modal-footer cost_button">
         <button className="cncl">Cancel</button>
         <button className="procd">Ok</button>
        </div> */}
      </div>
    </div>
  ) : null;
};

export default Modal;



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/requestCoupon.js